import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as gtm from '../../../../lib/gtm';
import Photo from '../../../atoms/Photo';
import { ReactComponent as RemoveIcon } from '../../../../assets/img/remove.svg';
import { ReactComponent as AddIcon } from '../../../../assets/img/add.svg';
import {
  changeQuantity,
  removeProduct,
} from '../../../../store/modules/cart/actions';

import * as S from './styles';

const Resume = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { language } = useSelector((state) => state.language);
  const formatCurrency = (price, locale = 'pt-BR') =>
    price.toLocaleString(locale, {
      style: 'currency',
      currency: 'BRL',
    });

  const total = useSelector((state) =>
    state.cart.products.reduce(
      (partialTotal, product) =>
        partialTotal + product.price * product.quantity,
      0
    )
  );

  useEffect(() => {
    gtm.viewCart({
      value: cart.products.reduce(
        (partialTotal, product) =>
          partialTotal + product.price * product.quantity,
        0
      ),
      items: cart.products.map((product, index) => ({
        index,
        item_id: String(product.id),
        item_name: product.name,
        currency: 'BRL',
        item_category: product.category.name,
        item_category2: 'Site do casal',
        item_list_id: product.item_list_id,
        item_list_name: product.item_list_name,
        price: product.price,
        quantity: product.quantity,
      })),
    });
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, []);

  const handleChangeProductQuantity = (action, productId) => {
    dispatch(changeQuantity(action, productId));
    const product = cart.products.find((p) => p.id === productId);
    const gtmEvent = action === 'increase' ? gtm.addToCart : gtm.removeFromCart;
    gtmEvent({
      value: product.price,
      items: [
        {
          item_id: String(product.id),
          item_name: product.name,
          currency: 'BRL',
          item_category: product.category.name,
          item_category2: 'Site do casal',
          item_list_id: product.item_list_id,
          item_list_name: product.item_list_name,
          price: product.price,
        },
      ],
    });
  };

  const handleRemoveProduct = (productId) => {
    dispatch(removeProduct(productId));
    const product = cart.products.find((p) => p.id === productId);
    gtm.removeFromCart({
      value: product.price * product.quantity,
      items: [
        {
          item_id: String(product.id),
          item_name: product.name,
          currency: 'BRL',
          item_category: product.category.name,
          item_category2: 'Site do casal',
          item_list_id: product.item_list_id,
          item_list_name: product.item_list_name,
          price: product.price,
          quantity: product.quantity,
        },
      ],
    });
  };

  return (
    <S.Wrapper data-testid="ResumeCart">
      <S.Container>
        <S.Header>
          <S.Column>Descrição</S.Column>
          <S.Column>Quantidade</S.Column>
          <S.Column rightAlign>Valor</S.Column>
        </S.Header>
        {cart.products.map((product) => (
          <S.Product key={product.id}>
            <S.Column>
              <Photo proportion="1:1" url={product.image} maxWidth="65px" />
              <S.ProductTitle>{product.name}</S.ProductTitle>
            </S.Column>
            <S.Column>
              <div>
                <S.QuantityWrapper>
                  <S.QuantityButton
                    disabled={product.quantity <= 1}
                    onClick={() =>
                      handleChangeProductQuantity('decrease', product.id)
                    }
                  >
                    <RemoveIcon />
                  </S.QuantityButton>
                  <S.QuantityBox>{product.quantity}</S.QuantityBox>
                  <S.QuantityButton
                    disabled={product.quantity >= product.remaining_quantity}
                    onClick={() =>
                      handleChangeProductQuantity('increase', product.id)
                    }
                  >
                    <AddIcon />
                  </S.QuantityButton>
                </S.QuantityWrapper>
                <S.DeleteItem onClick={() => handleRemoveProduct(product.id)}>
                  Remover
                </S.DeleteItem>
              </div>
            </S.Column>
            <S.Column rightAlign>
              {formatCurrency(
                product.price * product.quantity,
                language.htmlTag
              )}
            </S.Column>
          </S.Product>
        ))}
        <S.Footer>
          <S.Column />
          <S.Column>Total</S.Column>
          <S.Column rightAlign>
            {formatCurrency(total, language.htmlTag)}
          </S.Column>
        </S.Footer>
      </S.Container>
    </S.Wrapper>
  );
};

export default Resume;
